import React, { useRef, useState, useEffect } from 'react';
import cx from "classnames";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import CalculatorIcon from '../../../static/icons/calculator.svg';
import CalculatorMobileIcon from '../../../static/icons/calculator_mobile.svg';

import LoopIcon from '../../../static/icons/loop.svg';
import LoopMobileIcon from '../../../static/icons/loop_mobile.svg';

import RouteIcon from '../../../static/icons/route.svg';
import RouteMobileIcon from '../../../static/icons/route_mobile.svg';

import ContainerIcon from '../../../static/icons/container.svg';
import ContainerMobileIcon from '../../../static/icons/container_mobile.svg';

import TrackingIcon from '../../../static/icons/tracking.svg';
import TrackingMobileIcon from '../../../static/icons/tracking_mobile.svg';

import ExportIcon from '../../../static/icons/export.svg';
import ExportMobileIcon from '../../../static/icons/export_mobile.svg';

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";
import {VEDMARKET_LINKS} from '../../../constants';

import styles from './Functionality.module.scss';

function Functionality() {

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollDown = () => {
    scrollContainerRef.current?.scrollBy({ top: 250, behavior: 'smooth' });
  };

  const scrollUp = () => {
    scrollContainerRef.current?.scrollBy({ top: -250, behavior: 'smooth' });
  };

  const cards = [
    {
      title: 'Калькулятор стоимости поставки товаров',
      content: <span>Понятный расчет стоимости импорта с&nbsp;учетом доставки, таможенных платежей и&nbsp;остальных расходов.</span>,
      image: isMobile ? CalculatorMobileIcon : CalculatorIcon,
    },
    {
      title: 'Точный подбор ТН ВЭД кодов',
      content: <span>Поиск кода ТН&nbsp;ВЭД и&nbsp;классификация товара с&nbsp;помощью искусственного интеллекта.</span> ,
      image: isMobile ? LoopMobileIcon : LoopIcon,
    },
    {
      title: 'Автоматический расчет оптимального маршрута',
      content: <span>Интеллектуальный подбор маршрута с&nbsp;учетом типа груза, сроков доставки и&nbsp;фрахтов</span>,
      image: isMobile ? RouteMobileIcon : RouteIcon,
    },
    {
      title: 'Оптимизация загрузки в контейнер',
      content: 'Автоматизированный расчет пространства для максимально эффективного размещения груза',
      image: isMobile ? ContainerMobileIcon : ContainerIcon,
    },
    {
      title: 'Онлайн-трекинг перемещения груза',
      content: <span>Детали транзита с&nbsp;прогнозом сроков доставки и&nbsp;уведомлениями о&nbsp;каждом этапе перевозки</span>,
      image: isMobile ? TrackingMobileIcon : TrackingIcon,
    },
    {
      title: 'Импорт данных по товарам и экспорт расчетов',
      content: <span>Вы&nbsp;можете загрузить файл со&nbsp;списком товаров и&nbsp;их&nbsp;характеристиками, а&nbsp;также скачать и&nbsp;распечать итоговый расчет</span>,
      image: isMobile ? ExportMobileIcon : ExportIcon,
    },
  ]

  return (
      <div className={styles.functionality} id='how-to'>
        <Container className={styles.functionalityContainer}>
          <Row className={styles.contentContainer}>
            <Col xl={6} className='p-0'>
              <div className={styles.howToContent}>
                <div className={styles.cardScrollVerticalWrapper}>

                  <div ref={scrollContainerRef} className={styles.scrollContainerVertical}>
                    {cards.map((card, index) => (
                        <div className={styles.card} key={index}>
                          <img src={card.image} alt={card.title} className={styles.cardImage}/>
                          <div className={styles.cardText}>
                            <h4 className={styles.cardTitle}>{card.title}</h4>
                            <p className={styles.cardContent}>{card.content}</p>
                          </div>
                        </div>
                    ))}
                  </div>

                  <div className={styles.scrollButtons}>
                    <div className={styles.scrollButtonUp} onClick={scrollUp}>
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.82 31.4099L24 22.2499L33.18 31.4099L36 28.5899L24 16.5899L12 28.5899L14.82 31.4099Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div className={styles.scrollButtonDown} onClick={scrollDown}>
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.82 31.4099L24 22.2499L33.18 31.4099L36 28.5899L24 16.5899L12 28.5899L14.82 31.4099Z" fill="currentColor"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={6}>
              <h2 className={styles.title}>Как это работает</h2>
              <h3 className={styles.subtitle}>Функционал <br/> с&nbsp;пониманием ваших потребностей</h3>
              <p className={styles.text}>
                Огромный опыт в&nbsp;области международных закупок позволил реализовать мощный сервис, продуманный до&nbsp;мелочей.
              </p>
              <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonTop}/>
            </Col>
          </Row>
          <Row className={cx(styles.contentContainer, styles.contentContainerBottom)}>
            <Col xl={12} className='p-0'>
              <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonBottom}/>
            </Col>
          </Row>
        </Container>
      </div>
  );
}

export default Functionality;
